import {useHistory} from "react-router-dom";
import {useState} from "react";
import ApiService from "../services/ApiService";
import {Button, Form, Input} from "antd";

export default function ResetPassword() {
    const params = new URLSearchParams(window.location.search);
    const key = params.get('key');

    const history = useHistory();
    const [loading, setLoading] = useState(false)

    const sendLink = async (form) => {
        setLoading(true)
        const res = await ApiService.Auth.ResetPassword(key, form)
        setLoading(false)
        if(res.success) {
            history.push('/app/reset-password/success')
        }
    }

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                <div style={{width: '50%', height: '50%', display: 'flex', alignItems: 'center', minHeight: 500, minWidth: 1000}}>
                    <div style={{flex: 1, backgroundColor: '#035781', height: '100%', width: '100%', display: 'flex', alignItems: 'center'}}>
                        <div style={{width: '100%', display: "flex", alignItems: 'center', flexDirection: 'column'}}>
                            <img src={'/LogoB41.png'} width={256} height={256}/>
                        </div>
                    </div>
                    <div style={{flex: 1, height: '100%', backgroundColor: '#fff', display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '10%', marginRight: '10%'}}>
                            <div style={{fontSize: '23pt'}}>
                                Reset Password
                            </div>
                            <br/>
                            <Form
                                layout={'vertical'}
                                name="basic"
                                initialValues={{ remember: true }}
                                autoComplete="off"
                                onFinish={sendLink}
                            >
                                <Form.Item
                                    required={false}
                                    style={{flex: 1}}
                                    name="password"
                                    label={(<span style={{fontSize: '13pt'}}>Password</span>)}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                            min: 6
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password style={{fontSize: '13pt'}} />
                                </Form.Item>

                                <Form.Item
                                    required={false}
                                    style={{flex: 1}}
                                    name="password2"
                                    label={(<span style={{fontSize: '13pt'}}>Confirm Password</span>)}
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please confirm your password!',
                                            min: 6
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password style={{fontSize: '13pt'}} />
                                </Form.Item>

                                <div style={{width: 400}}>
                                    <Button
                                        loading={loading}
                                        type="primary"
                                        htmlType="submit"
                                        size={'large'}
                                        style={{fontSize: '13pt', padding: 'none',
                                            paddingBottom: 8}}
                                    >
                                        <div style={{marginTop: -2}}>
                                            Reset
                                        </div>
                                    </Button>
                                </div>
                            </Form>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}